( function ( $ ) {
  $.fn.syncInput = function ( options ) {
    const settings = $.extend(
      {
        event: "input",
        target: null
      },
      options
    )

    let syncing = false

    return this.each( function () {
      const $source = $( this )
      const $targets = settings.target
        ? $( settings.target )
        : $source

      $source.on( settings.event, function () {
        if ( syncing ) return

        syncing = true
        const value = $source.val()

        $targets.not( $source ).val( value ).trigger( settings.event )
        syncing = false
      } )
    } )
  }
} )( jQuery )